var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconConciergeService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.083 12.385h2V8.69h-2zM21.84 12.964l-2.83-2.375-1.285 1.532 2.83 2.375zM30.44 12.121l-1.285-1.532-2.83 2.375 1.285 1.532zM21.09 24a3.162 3.162 0 012.993-2.153A3.16 3.16 0 0127.073 24h-5.982zm3.993-4.052V18.15h2v-2h-6v2h2v1.797A5.165 5.165 0 0019.03 24h-1.351c-.251-3.158-1.668-5.962-3.843-7.467a.998.998 0 00-1.391.253.999.999 0 00.252 1.39c1.627 1.127 2.747 3.345 2.987 5.824H5.048c.24-2.48 1.359-4.697 2.986-5.823a.999.999 0 10-1.138-1.644C4.72 18.038 3.304 20.842 3.052 24H2v2h28v-2h-.864a5.165 5.165 0 00-4.053-4.052zM10.366 7.985a2.918 2.918 0 012.914 2.914 2.918 2.918 0 01-2.914 2.914 2.918 2.918 0 01-2.914-2.914 2.918 2.918 0 012.914-2.914m0 7.828a4.919 4.919 0 004.914-4.914 4.92 4.92 0 00-4.914-4.914 4.92 4.92 0 00-4.914 4.914 4.919 4.919 0 004.914 4.914"
  })))));
}

export default SvgIconConciergeService;